import React, {useCallback, useState} from 'react'
import {useDropzone} from 'react-dropzone'
import {TextField, Button, InputAdornment, Modal, Box, Typography} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import styles from '../../assets/styles/modules/Admin.module.css'
import {getUserList, registerNews, upLoadImg} from "../../apis/adminApis";


const Admin = () => {
    const style = {
        position: 'absolute',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        boxShadow: 10,
        p: 4,
        padding: '16px'
    };

    const [modalOpen, setModalopen] = useState(false) //후보자 검색 모달창 오픈 여부
    const [userName, setUserName] = useState('') // 후보자 이름
    const [userList, setUserList] = useState([]) // 후보자 이름

    const [userId, setUserId] = useState('') //후보자 코드
    const [title, setTitle] = useState('') // 뉴스 기사 제목
    const [content, setContent] = useState('') // 뉴스 본문
    const [fileName, setFileName] = useState('') // 이미지 파일 이름

    // 이미지 파일 drag&drop 이벤트 핸들러
    const onDrop = useCallback(acceptedFiles => {
        const formData = new FormData();
        formData.append("image", acceptedFiles[0]);
        upLoadImg(formData)
            .then(res => setFileName(res))
            .catch(err => console.log(err))
    }, [])

    const {acceptedFiles,getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    // 이미지 파일 명, 사이즈 값 관련 변수
    const files = acceptedFiles.map(file => `${file.path} - ${file.size} bytes`);


    //후보자 검색 이벤트 핸들러
    const insertUserName = (e) => {
        setUserName(e.target.value)
        setUserId('')
    }

    // 후보자 검색 버튼 클릭 핸들러
    const searchUserList = () => {
        if(userName.length > 1){
            getUserList(userName)
                .then(res => {
                    setModalopen(true)
                    setUserList(res)
                })
                .catch(err => console.error(err.message))
        }else {
            alert('후보자 이름을 두글자 이상 입력해주세요.')
        }
    }

    // 후보자 선택 함수
    const selectUser = (user) => {
        setUserId(user.userid)
        setUserName(user.name)
        setModalopen(false) // 선택 되면 모달창 닫음
    }


    // 뉴스 제목 입력 핸들러
    const insertTitle = (e) => setTitle(e.target.value)
    // 뉴스 본문 입력 핸들러
    const insertContent = (e) => setContent(e.target.value)

    // 뉴스 등록하기 버튼 클릭 이벤트
    const submitNews =  () => {
        if(!!userId && !!title && !!content){
            registerNews(userId, title, content,fileName)
                .then(res => {
                    alert('뉴스 등록 성공')
                    setUserName('')
                    setUserList([])
                    setUserId('')
                    setTitle('')
                    setContent('')
                })
                .catch(err => alert(err.message))
        }else {
            if(!!userId === false){
                alert('후보자 코드를 다시 선택해주세요')
            }else {
                alert('모든 필드를 작성해주세요')
            }
        }
    }


    return (
        <div className='container'>
            <div className='admin inner_container'>
                <div>
                    <span className={`${styles.label} ${styles.inline}`}>인물 검색</span>
                    <TextField
                        id="input-with-icon-textfield"
                        sx={{
                            marginBottom: '30px',
                            marginLeft: '12px',
                            width: '40%',
                            '& .MuiOutlinedInput-input': {padding: '8px', fontSize: '16px'}
                        }}
                        onChange={insertUserName}
                        onKeyUp={(e) => {
                            if (e.keyCode === 13) searchUserList()
                        }}
                        value={userName}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Button variant="outlined" sx={{marginLeft: '12px', height: '39px'}}
                            onClick={searchUserList}>검색</Button>
                    <Modal open={modalOpen} onClose={() => setModalopen(false)}>
                        <Box sx={style}>
                            <div className={`${styles.userList} ${styles.tableHeader}`}>
                                <p>이름</p>
                                <p>소속</p>
                                <p>고유번호</p>
                            </div>
                            {userList && userList.map(user =>
                                <div key={user.userid} className={styles.userList} onClick={() => selectUser(user)}>
                                    <p>{user.name}</p>
                                    <p>{user.party}</p>
                                    <p>{user.userid}</p>
                                </div>)}
                        </Box>
                    </Modal>
                </div>
                <p className={styles.label}>제목을 입력해주세요.</p>
                <TextField
                    id="outlined-multiline-static"
                    sx={{marginBottom: '30px', '& .MuiOutlinedInput-root': {padding: '8px', fontSize: '16px'}}}
                    onChange={insertTitle}
                    multiline
                    fullWidth
                    value={title}
                />
                <p className={styles.label}>본문 내용을 입력해주세요.</p>
                <TextField
                    id="outlined-multiline-static"
                    sx={{
                        marginBottom: '30px',
                        '& .MuiOutlinedInput-root': {padding: '8px', fontSize: '16px', lineHeight: '1.5'}
                    }}
                    onChange={insertContent}
                    multiline
                    rows={12}
                    fullWidth
                    value={content}
                />
                <div className={`${styles.dndBox} ${isDragActive ? 'uploading' : ''}`} {...getRootProps()}>
                    <input {...getInputProps()}/>
                    <div>
                        <DriveFolderUploadIcon
                            sx={{display: 'block', margin: '0 auto', fontSize: '45px', color: '#3e647d'}}/>
                        {isDragActive ? <p>uploading ...</p> : <p>Drag and drop here, or click to select file</p>}
                        <span>{files}</span>
                    </div>
                </div>
                <div className={styles.submitBtn}>
                    <Button variant="contained" sx={{'&:hover': {backgroundColor: "#204662"}}} onClick={submitNews}>등록하기</Button>
                </div>
            </div>
        </div>
    );
};

export default Admin;